import styled, { css, keyframes } from 'styled-components'

export interface PriceElementPeriodSavingUiProps {
  isVisible: boolean
}

export const SwitchLabelUi = styled.label`
  position: relative;
  display: inline-block;
  width: 72px;
  height: 38px;
`

export const SwitchSliderUi = styled.span`
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: #ccc;
  transition: background-color 0.4s;
  border-radius: 100px;
  cursor: pointer;

  &:before {
    content: "";
    position: absolute;
    top: 4px;
    left: 4px;
    width: 30px;
    height: 30px;
    background-color: white;
    border-radius: 50%;
    transition: transform 0.4s;
  }
`

export const SwitchInputUi = styled.input.attrs({ type: 'checkbox' })`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + ${SwitchSliderUi} {
    background-color: #00A0FF;
  }

  &:checked + ${SwitchSliderUi}::before {
    transform: translateX(34px);
  }
`

export const PriceElementPeriodSwitcherUi = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  font-weight: 500;
  font-size: 24px;
  line-height: 30px;
  border-radius: 5px;
  overflow: hidden;

  ${p => p.theme.phone} {
    display: none;
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
    display: none;
  `}
`

export const PriceElementPeriodSwitcherLabelUi = styled.span<{
  isActive: boolean
}>`
  color: #181c39;
  opacity: ${p => (p.isActive ? 1 : 0.6)};
  transition: opacity 0.3s ease;
`

const shake = keyframes`
  10%, 90% { transform: translateX(-1px); }
  20%, 80% { transform: translateX(2px); }
  30%, 50%, 70% { transform: translateX(-2px); }
  40%, 60% { transform: translateX(2px); }
`

export const PriceElementPeriodSavingUi = styled.div<PriceElementPeriodSavingUiProps>`
  position: relative;
  color: #181c39;
  background-color: rgb(179, 252, 106);
  padding: 6px 16px;
  border-radius: 68px;
  font-weight: 700;
  font-size: 18px;
  white-space: nowrap;
  visibility: hidden;

  ${props =>
    props.isVisible &&
    css`
      visibility: visible;
      animation: ${shake} 0.5s;
    `}
`
